import React from 'react';
import { Check, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative bg-gradient-to-b from-[#e8f4fc] to-white overflow-hidden" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20" data-id="element-2">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-3">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="z-10" data-id="element-4">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#1e4d7b]/10 text-[#1e4d7b] font-semibold text-sm mb-6" data-id="element-5">
              Método 100% Natural y Efectivo
            </span>
            <h1 className="text-4xl lg:text-6xl font-extrabold text-[#1e4d7b] leading-tight mb-6" data-id="element-6">
              ¿Harta de luchar contra los piojos? <br data-id="element-7" />
              <span className="text-[#4a90c2]" data-id="element-8">
                Elimínalos hoy y para siempre.
              </span>
            </h1>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed max-w-xl" data-id="element-9">
              No gastes un euro más en farmacias. Descubre el sistema natural
              que
              <strong data-id="element-10"> corta el ciclo de vida </strong> del piojo desde la raíz.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-11">
              {['Elimina piojos desde la primera aplicación.', 'Protege textiles y objetos personales.', 'Rutina diaria para prevenir reinfestación.'].map((item, index) => <li key={index} className="flex items-start" data-id="element-12">
                  <div className="flex-shrink-0 h-6 w-6 rounded-full bg-[#4a90c2] flex items-center justify-center mt-0.5" data-id="element-13">
                    <Check className="h-4 w-4 text-white" data-id="element-14" />
                  </div>
                  <span className="ml-3 text-gray-700 font-medium" data-id="element-15">{item}</span>
                </li>)}
            </ul>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4" data-id="element-16">
              <button onClick={() => {
              document.getElementById('offer-section')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} className="w-full sm:w-auto px-8 py-4 bg-[#1e4d7b] hover:bg-[#163a5e] text-white font-bold rounded-lg shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-0.5 flex items-center justify-center gap-2 text-lg" data-id="element-17">
                Quiero acceso a Hogar Blindado
                <ArrowRight className="h-5 w-5" data-id="element-18" />
              </button>
            </div>
            <p className="mt-4 text-sm text-gray-500 flex items-center gap-2" data-id="element-19">
              <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-20"></span>
              Acceso inmediato • Digital • Para toda la familia
            </p>
          </motion.div>

          {/* Image Content */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-21">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-22">
              <img src="https://cdn.magicpatterns.com/uploads/8Qhp8LZNNFFDH3H8jGh57V/HERO_1.png" alt="Hogar Blindado E-book y Audioguía" className="w-full h-auto object-cover" data-id="element-23" />
            </div>
            {/* Decorative elements */}
            <div className="absolute -z-10 top-10 -right-10 w-72 h-72 bg-[#4a90c2]/20 rounded-full blur-3xl" data-id="element-24"></div>
            <div className="absolute -z-10 -bottom-10 -left-10 w-72 h-72 bg-[#1e4d7b]/10 rounded-full blur-3xl" data-id="element-25"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}